import { render, staticRenderFns } from "./MembershipMain.vue?vue&type=template&id=567afd9c&"
import script from "./MembershipMain.vue?vue&type=script&lang=js&"
export * from "./MembershipMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports